import React, {Component} from 'react';
import PhoneNumberConfirmModal from "./modals/PhoneNumberConfirm/PhoneNumberConfirmModal";
import './Profile.css';
import ProfileGeneral from "./General/ProfileGeneral";
import ProfileCompany from "./Company/ProfileCompany";
import ProfileNotifications from "./Notifications/ProfileNotifications";

class Profile extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};

    render() {
        return (
            <div>
                <div className="page-header m-b-0 p-b-0 b-b-0">
                    <h1><span className="text-muted font-weight-light">Настройки</span> учётной записи</h1>
                    <ul className="nav nav-tabs page-block m-t-4" id="account-tabs">
                        <li className="active">
                            <a href="#account-profile" data-toggle="tab">Профиль</a>
                        </li>
                        <li>
                            <a href="#account-social" data-toggle="tab">Компания</a>
                        </li>
                        <li>
                            <a href="#account-notifications" data-toggle="tab">Уведомления</a>
                        </li>
                    </ul>
                </div>
                <div className="tab-content p-y-4">
                    <div className="tab-pane fade in active" id="account-profile">
                        <ProfileGeneral/>
                    </div>
                    <div className="tab-pane fade" id="account-social">
                        <ProfileCompany/>
                    </div>
                    <div className="tab-pane fade" id="account-notifications">
                        <ProfileNotifications/>
                    </div>
                </div>
                <PhoneNumberConfirmModal/>
            </div>
        );
    }
}

export default Profile;


// WEBPACK FOOTER //
// ./src/pages/Profile/Profile.js